import React from 'react'
import injectSheet from 'react-jss'
import styles from './trainings-entry.styles'
import { Cell, TableRow } from 'pobble-components/dist/table'
// import CircleStatus from 'pobble-components/dist/circle-status'
import { Link } from 'react-router-dom'
import ContextMenu from './context-menu/context-menu.container'
import AgeGroup from 'pobble-components/dist/age-group'

const TrainingsEntry = ({
  classes,
  id,
  title,
  conclusion,
  createdAt,
  pending,
  link,
  student,
  thumb,
  author,
  ageGroupOrder,
  ageGroupTitle
}) => (
  <TableRow pending={pending}>
    <Cell className={classes.thumbnail}>
      <Link to={link}>
        <span style={{ backgroundImage: `url("${thumb}")` }} />
      </Link>
    </Cell>
    <Cell className={classes.date}>{createdAt}</Cell>
    <Cell className={classes.date}>{author}</Cell>
    <Cell>
      <Link className={classes.link} to={link}>
        {title}
      </Link>
    </Cell>
    <Cell>
      <AgeGroup order={ageGroupOrder}>{ageGroupTitle}</AgeGroup>
    </Cell>
    <Cell right>
      <ContextMenu id={id} />
    </Cell>
    {/*<Cell>{student}</Cell>/*}
    {/*<Cell className={classes.center}>
      <CircleStatus status={conclusion} />
    </Cell>*/}
  </TableRow>
)

export default injectSheet(styles)(TrainingsEntry)
